import { Calendar, CalendarDays, CalendarRange } from 'lucide-react'

export type DashboardView = 'today' | 'week' | 'calendar'

interface ViewSelectorProps {
  activeView: DashboardView
  onChange: (view: DashboardView) => void
}

const views: { key: DashboardView; label: string; icon: typeof Calendar; disabled?: boolean }[] = [
  { key: 'today', label: 'Today', icon: Calendar },
  { key: 'week', label: 'This Week', icon: CalendarDays },
  { key: 'calendar', label: 'Calendar', icon: CalendarRange, disabled: true },
]

export function ViewSelector({ activeView, onChange }: ViewSelectorProps) {
  return (
    <div className="inline-flex bg-surface-card rounded-lg p-1 gap-1">
      {views.map(({ key, label, icon: Icon, disabled }) => {
        const isActive = activeView === key
        return (
          <button
            key={key}
            onClick={() => !disabled && onChange(key)}
            disabled={disabled}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
              isActive
                ? 'bg-quest-primary text-white'
                : disabled
                  ? 'text-gray-600 cursor-not-allowed'
                  : 'text-gray-400 hover:text-white hover:bg-surface-hover'
            }`}
          >
            <Icon className="w-4 h-4" />
            {label}
          </button>
        )
      })}
    </div>
  )
}
